import http from 'common-module/src/util/http';

/**
 * 获取分享信息
 * @param shareCode 分享code
 * @returns {Promise<*>}
 */
export const shareInfo = async (shareCode) => {
  return http.post('/anonymous/share/unauth-info', { shareCode }, { showError: false });
};

/**
 * 分享用户登录获取token
 * @param shareCode 分享code
 * @param password 分享密码
 * @returns {Promise<*>}
 */
export const shareAnonymousLogin = async (shareCode, password) => {
  return http.post('/anonymous/share/login', { shareCode, password }, { showError: false });
};
